import React from 'react';

const ChatPanelContext = React.createContext({});

export default ChatPanelContext;

export const MessagesLoadingContext = React.createContext({
  loadingMoreMessages: false,
  setLoadingMoreMessages: () => {},
});

export const VoiceRecordingContext = React.createContext({
  isRecording: false,
  isPaused: false,
  recordingTime: 0,
  waveformHeights: [],
  startRecording: () => {},
  stopAndSend: () => {},
  cancelRecording: () => {},
  pauseRecording: () => {},
  resumeRecording: () => {},
});
